import { render } from "./OrderInNext.vue?vue&type=template&id=aab3362a"
import script from "./OrderInNext.vue?vue&type=script&lang=js"
export * from "./OrderInNext.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__